import React from 'react';
import { Box, Typography, Grid2, Paper, Icon, useTheme } from '@mui/material';
import Section from './Section';

const SeccionQueEs = () => {
  const theme = useTheme();

  const features = [
    {
      icon: 'touch_app',
      title: 'Fácil de Usar',
      description: 'Crea y gestiona tus rifas en minutos gracias a una interfaz intuitiva pensada para organizadores y compradores.',
      color: '#2d3484',
    },
    {
      icon: 'dashboard_customize',
      title: 'Control Total en Tiempo Real',
      description: 'Monitorea boletos disponibles, reservados y pagados. Cualquier reserva se actualiza al instante en todos los dispositivos.',
      color: '#f15b28',
    },
    {
      icon: 'notifications_active',
      title: 'Notificaciones Automáticas',
      description: 'La app envía confirmaciones de reserva a tus compradores y te avisa cuando alguien solicita números.',
      color: '#10b981',
    },
    {
      icon: 'insights',
      title: 'Estadísticas y Reportes',
      description: 'Visualiza el recaudo total, porcentaje de avance de la rifa y exporta tus listados de compradores en Excel, PDF o CSV.',
      color: '#6861a5',
    },
    {
      icon: 'qr_code_2',
      title: 'Códigos QR y Enlaces Seguros',
      description: 'Comparte tu rifa mediante enlaces cortos y códigos QR descargables listos para imprimir o publicar en redes.',
      color: '#0284c7',
    },
    {
      icon: 'security',
      title: 'Seguridad y Transparencia',
      description: 'Arquitectura protegida con tecnología de cifrado que garantiza la autenticidad y orden de cada número jugado.',
      color: '#e11d48',
    },
  ];

  return (
    <Section
      id="que-es"
      title="¿Qué es Mi Rifa App?"
      subtitle="La solución más completa y moderna para crear, administrar y comercializar tus rifas desde tu teléfono móvil o en la web."
      hasBackground={false}
    >
      <Grid2 container spacing={3}>
        {features.map((item, index) => (
          <Grid2 key={index} size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              elevation={0}
              sx={{
                p: 3.2,
                height: '100%',
                borderRadius: '16px',
                border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid #e2e8f0',
                bgcolor: theme.palette.background.paper,
                transition: 'all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: theme.palette.mode === 'dark' ? '0 4px 16px rgba(0, 0, 0, 0.3)' : '0 2px 10px rgba(0, 0, 0, 0.03)',
                '&:hover': {
                  transform: 'translateY(-6px)',
                  boxShadow: theme.palette.mode === 'dark' ? '0 14px 32px rgba(0, 0, 0, 0.6)' : '0 14px 32px rgba(45, 52, 132, 0.12)',
                  borderColor: item.color,
                  '& .feature-icon-box': {
                    transform: 'scale(1.12) rotate(4deg)',
                    bgcolor: `${item.color}15`,
                    borderColor: item.color,
                  },
                },
              }}
            >
              {/* Icono outlined con fondo suave y micro-animación al hover */}
              <Box
                className="feature-icon-box"
                sx={{
                  width: 52,
                  height: 52,
                  borderRadius: '12px',
                  bgcolor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.04)' : '#f8fafc',
                  border: theme.palette.mode === 'dark' ? '1px solid rgba(255, 255, 255, 0.08)' : '1px solid #e2e8f0',
                  color: item.color,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 2.2,
                  transition: 'all 0.3s ease',
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.02)',
                }}
              >
                <Icon sx={{ fontSize: 26, color: item.color }}>{item.icon}</Icon>
              </Box>

              <Typography variant="h6" sx={{ fontWeight: 800, mb: 1, color: theme.palette.text.primary, fontSize: '1.05rem' }}>
                {item.title}
              </Typography>

              <Typography variant="body2" sx={{ color: theme.palette.text.secondary, lineHeight: 1.6, flex: 1 }}>
                {item.description}
              </Typography>
            </Paper>
          </Grid2>
        ))}
      </Grid2>
    </Section>
  );
};

export default SeccionQueEs;